<crm-opportunity-association-panel [id]="id" [name]="name" [objectType]="'Company'">
</crm-opportunity-association-panel>
